import { createFileRoute } from '@tanstack/react-router';
import {
  TabbedPageLayout,
  type RoutedTab,
} from '@/components/tabbed-page-layout';

// Open to all members: the MCP tab is a personal connection; the API tab gates itself.
export const Route = createFileRoute('/_auth/_side-layout/integrations/access')(
  {
    component: () => (
      <TabbedPageLayout
        title="AI & API Access"
        description="Connect AI assistants over MCP, or call the REST API with API keys and OAuth clients."
        tabs={TABS}
      />
    ),
  },
);

const TABS: RoutedTab[] = [
  { to: '/integrations/access/mcp', label: 'AI Assistants (MCP)' },
  { to: '/integrations/access/api', label: 'API Keys & OAuth' },
];
